"use client";

import { TVacancyPlatformInfo } from "@shared/cms";
import { imageFallback } from "@shared/utils";
import Image from "next/image";
import { Vacancy } from "../types";

type VacancyPlatformInfoProps = {
  vacancy: Vacancy;
  preset?: boolean;
  nativeClass?: string;
  contentClass?: string;
  meta: TVacancyPlatformInfo;
};
export function VacancyPlatformInfo({ vacancy, preset, nativeClass, contentClass, meta }: VacancyPlatformInfoProps) {
  const isExternal = (vacancy: Vacancy) => {
    if (vacancy && vacancy?.platformType && vacancy?.platformType == "external") {
      return {
        ...vacancy?.platform,
        logoUrl: vacancy?.platform?.logoUrl || vacancy?.platformLogo,
        name: vacancy?.platform?.name || vacancy?.platformName,
        link: vacancy?.platformLink,
      };
    }

    return null;
  };

  return (
    <div className={"relative bg-gray-50 overflow-hidden text-sm " + (!preset ? "py-3 px-4 -mx-4 -mb-4 mt-4 " : "") + nativeClass}>
      {vacancy && (
        <div className="flex items-center gap-2 justify-between">
          <div className={contentClass + " text-gray-500 flex-1"}>
            {meta.label}
            <p className="font-semibold">{isExternal(vacancy)?.name || meta.defaultPlatformLabel}</p>
          </div>
          <div className="min-w-[3.75rem] text-right">
            {isExternal(vacancy) ? (
              <Image
                src={isExternal(vacancy)?.logoUrl || ""}
                onError={imageFallback()}
                alt={isExternal(vacancy)?.name || "Platform Logo"}
                className="h-5 w-auto object-contain inline-block"
                width={1000}
                height={1000}
              />
            ) : (
              meta.defaultPlatformLogo && (
                <Image
                  src={meta.defaultPlatformLogo.url}
                  onError={imageFallback()}
                  alt={meta.defaultPlatformLogo.alternativeText || meta.defaultPlatformLogo.name || ""}
                  className="h-5 w-auto object-contain inline-block"
                  width={meta.defaultPlatformLogo.width || 1000}
                  height={meta.defaultPlatformLogo.height || 1000}
                />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}
